"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferResponseToJSON = exports.OfferResponseFromJSONTyped = exports.OfferResponseFromJSON = exports.instanceOfOfferResponse = void 0;
var runtime_1 = require("../runtime");
var Offer_1 = require("./Offer");
/**
 * Check if a given object implements the OfferResponse interface.
 */
function instanceOfOfferResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfOfferResponse = instanceOfOfferResponse;
function OfferResponseFromJSON(json) {
    return OfferResponseFromJSONTyped(json, false);
}
exports.OfferResponseFromJSON = OfferResponseFromJSON;
function OfferResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'offer': !(0, runtime_1.exists)(json, 'offer') ? undefined : (json['offer'].map(Offer_1.OfferFromJSON)),
    };
}
exports.OfferResponseFromJSONTyped = OfferResponseFromJSONTyped;
function OfferResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'offer': value.offer === undefined ? undefined : (value.offer.map(Offer_1.OfferToJSON)),
    };
}
exports.OfferResponseToJSON = OfferResponseToJSON;
